import { create } from 'zustand'

/**
 * Tracks whether recent data requests are failing (timeout / network / 5xx), so a
 * global banner can offer «Повторить» instead of leaving the screen on an eternal
 * spinner. Set from the QueryClient cache (see lib/queryClient.ts).
 */
interface ConnectionState {
  degraded: boolean
  setDegraded: (v: boolean) => void
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  degraded: false,
  setDegraded: (v) => set((s) => (s.degraded === v ? s : { degraded: v })),
}))
